import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';
import moment from "moment";
import { monthNameFormatDate } from '../../../core/date';

const formatTime = value => {
  if (value) {
    return moment(value, "HH:mm:ss").format("hh:mm A");
  }
};

const displayDate = value => {
  if (value) {
    return monthNameFormatDate(value);
  } else {
    return '';
  }
};

class PropertyDetails extends React.Component {
  render() {
    const hotel = this.props.hotel;
    const taxFormatter = new Intl.NumberFormat('en-US', {
      style: 'percent',
      minimumFractionDigits: 3,
    });

    const checkIn = formatTime(hotel.check_in);
    const checkOut = formatTime(hotel.check_out);
    const taxRate = hotel.tax_rate >= 1 ? hotel.tax_rate +"%": taxFormatter.format(hotel.tax_rate);
    const builtDate = displayDate(hotel.year_built);
    const remodeledDate = displayDate(hotel.year_remodeled);
    return (
      <div className="row">
        <div className="col-md-12">
          <h4 className="hotel-highlight">
            Details <Button onClick={this.props.handleEdit}>Edit</Button>
          </h4>
        </div>
        <div className="col-md-3">
          <p>AAA Rating: {hotel.stars}</p>
          <p>Check-in Time: {checkIn}</p>
          <p>Check-out Time: {checkOut}</p>
          <p>Number of Rooms: {hotel.room_count}</p>
          <p>Number of Floors: {hotel.floors}</p>
        </div>

        <div className="col-md-3">
          <p>Restaurant Hours: {hotel.is_24hours_restaurant ? '24 Hours' : ((hotel.restaurant_from_time && hotel.restaurant_to_time) ? `${formatTime(hotel.restaurant_from_time)} to ${formatTime(hotel.restaurant_to_time)}` : 'NA')}</p>
          <p>Bar Hours: {hotel.is_24hours_bar ? '24 Hours' : ((hotel.bar_from_time && hotel.bar_to_time) ? `${formatTime(hotel.bar_from_time)} to ${formatTime(hotel.bar_to_time)}` : 'NA')}</p>
          <p>Gym Hours: {hotel.is_24hours_gym ? '24 Hours' : ((hotel.gym_from_time && hotel.gym_to_time) ? `${formatTime(hotel.gym_from_time)} to ${formatTime(hotel.gym_to_time)}` : 'NA')}</p>
          <p>Room Service Hours: {hotel.is_24hours_room_service ? '24 Hours' : ((hotel.room_service_from_time && hotel.room_service_to_time) ? `${formatTime(hotel.room_service_from_time)} to ${formatTime(hotel.room_service_to_time)}` : 'NA')}</p>
        </div>
        <div className="col-md-3">
          <p>Currency: {hotel.currency}</p>
          <p>Tax Rate: {taxRate}</p>
          <p>Additional Tax(per day): {hotel.currency}&nbsp;{hotel.additional_tax}</p>
          <p>Resort Fee(per day): {hotel.currency}&nbsp;{hotel.resort_fee}</p>
        </div>
        <div className="col-md-3">
          <p>Date Built:  {builtDate}</p>
          <p>Date Remodeled: {remodeledDate}</p>
        </div>
        <div className="col-md-12">
          <h4 className="hotel-highlight">Bus Parking</h4>
        </div>
        <div className="col-md-12">
          <p>Capacity: {hotel.bus_capacity}</p>
          <p>Parking Charges: {hotel.parking_charges} &nbsp;&nbsp; per:{hotel.per_day_night == 1 ? ' per day' : hotel.per_day_night == 2 ? ' per night' : ''}</p>
          <p>Notes: {hotel.bus_parking}</p>
        </div>
      </div>
    );
  }
}
PropertyDetails.propTypes = {
  hotel: PropTypes.object.isRequired,
  handleEdit: PropTypes.func.isRequired,
};
export default PropertyDetails;



// WEBPACK FOOTER //
// src/routes/hotels/components/PropertyDetailsView.js